import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Button } from '@material-ui/core';

import { authContext } from './../store/adalConfig';


const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
        paddingTop: 50

    },
    container: {
        display: "flex-grow",
    }
}));

function NoAccess(props) {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <Grid container spacing={0} className={classes.container} alignContent="center">
                <Grid item xs={12} align="center">
                    <h2>Unauthorized Access </h2>
                </Grid>
                {authContext.getCachedUser() ? (
                    <Grid item xs={12} align="center">
                        <Button onClick={() => authContext.logOut()} variant="contained">Logout</Button>
                    </Grid>
                ) : ""}
            </Grid>
        </div>
    );
}

export default NoAccess;
